/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/HighlightedArticles/theme';

export const HighlightedArticlesTheme = theme;
